export const authdApiRequest = async (url, options = {}) => {
  const token = localStorage.getItem('jwt');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    // Handle errors, e.g., log out the user if the token is invalid
    if (response.status === 401) {
      localStorage.removeItem('jwt');
      window.location.href = '/login';
    }
    throw new Error('Network response was not ok');
  }

  return response;
};
